import { Format } from "@/data/util/Format";
import { Misc } from "@/data/util/Misc";

import { logError } from "@/shared/logging/errors";
import { FloatLabel } from "@/shared/ui/FloatLabel";
import { Ripple } from "@/shared/ui/Ripple";

import { TastierClient } from "@/app/TastierClient";
import { trans } from "@/app/localization/Trans";
import { BasePopover } from "@/app/popover/BasePopover";
import { Popup } from "@/app/ui/Popup";

export class TableInfoPopover extends BasePopover {
    private $form: JQuery;
    private $submitBtn: JQuery;

    private locationId: string;
    private tableNumber: number;

    constructor(locationId: string, locationName: string, tableNumber: number) {
        super(trans.tableInfoPopover.title, false);

        this.tableNumber = tableNumber;

        this.$element.addClass("tableselection");
        this.locationId = locationId;

        this.$form = $('<form class="form" novalidate />').appendTo(this.$body);
        const row = $('<div class="formrow" />').appendTo(this.$form);
        row.append(
            '<div class="formcontrol"><label>' +
                trans.tableInfoPopover.textFieldLbl +
                '</label><input type="text" name="tableinfo" value="" /></div>'
        );

        this.$form.append(
            '<div class="welcome">' +
                trans.tableSelectionPopover.welcomeTo +
                " " +
                Format.htmlEscape(locationName) +
                "</div>"
        );
        this.$form.append('<div class="hint">' + trans.tableInfoPopover.hint + "</div>");
        this.$submitBtn = $('<button class="btn" type="submit">' + trans.general.continue + "</button>").appendTo(
            this.$form
        );
        Ripple.bind(
            this.$submitBtn.click((e) => {
                e.preventDefault();
                this.$form.submit();
            })
        );

        FloatLabel.bind(this.$form);
        this.$form.submit((e) => {
            e.preventDefault();
            e.stopPropagation();

            this.onSubmit();

            return false;
        });
    }

    protected onShow() {
        setTimeout(() => {
            if (!Misc.isIosDevice()) this.$form.find('input[name="tableinfo"]').focus();
        }, 200);
    }

    protected onHide() {
        this.destroy();
    }

    protected onDestroy() {}

    private async onSubmit() {
        if (this.$submitBtn.hasClass("loading")) return;

        const infoField = this.$form.find('input[name="tableinfo"]');
        const tableInfo = infoField.val().length === 0 ? undefined : infoField.val();
        if (tableInfo === undefined) {
            infoField.parent().addClass("has-error");
            return;
        } else infoField.parent().removeClass("has-error");

        this.$submitBtn.addClass("loading").prop("disabled", true);
        try {
            await TastierClient.context.allocate(this.locationId, this.tableNumber, tableInfo, false);
            this.hide();
        } catch (ex) {
            logError(ex);
            Popup.show(trans.allocation.allocationFailed);
            this.$submitBtn.removeClass("loading").prop("disabled", false);
        }
    }

    public static isAlreadyOpen() {
        return $(".app > .popover.tableselection").length !== 0;
    }
}
